import { ICreateClientOptions, ITokenAuthenticatedHttpClientFactory } from '@wix/ai-scheduling-assistant-common-lib/commonTypes';
import { SEND_MESSAGE_TIME_BUDGET } from '@wix/ai-scheduling-assistant-constants';
import { HttpClient, IHttpClient } from '@wix/http-client';

export class TokenAuthenticatedHttpClientFactory implements ITokenAuthenticatedHttpClientFactory {
  createHttpClient(token: string | null, options?: ICreateClientOptions): IHttpClient {
    return new HttpClient({
      ...options,
      timeout: SEND_MESSAGE_TIME_BUDGET,
      createHeaders: () => {
        return {
          Authorization: window.__VISITOR_SIGNED_INSTANCE__,
          'X-Time-Budget': `${SEND_MESSAGE_TIME_BUDGET}`,
          'X-User-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
          ...(token ? { 'X-Orion-Auth': `Bearer ${token}` } : {}),
        };
      },
    });
  }
}
